// import React from "react";
// // import { Award } from "tabler-icons-react";
// // import {
// //   Award,
// //   Users,
// //   Settings,
// //   Target,
// //   BarChart3,
// //   Beaker,
// // } from "tabler-icons-react";
// import { Award, Users, Settings, Target, Beaker } from "tabler-icons-react";

// export default function Certificate() {
//   return (
//     <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-2xl text-center hover:shadow-lg transition-shadow max-w-xl mx-auto">
//       <div className="bg-purple-500 p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center">
//         <Award className="w-8 h-8 text-white" />
//       </div>
//       <h4 className="text-xl font-bold text-gray-900 mb-4">
//         Industry Recognition
//       </h4>
//       <p className="text-gray-600 mb-4">
//         Recognized as Nepal's leading manufacturer of ultrasonic milk analyzers
//         with multiple industry awards.
//       </p>
//       <div className="bg-white p-4 rounded-lg">
//         <span className="text-sm font-semibold text-purple-600">
//           Award Winner 2023
//         </span>
//       </div>
//     </div>
//   );
// }

// import React from "react";
// import isours from "../image/iso-urs.png";
// import neapallogo from "../image/epal-logo.png";
// import trademarklogo from "../image/iso-urs.png";

// const certifications = [
//   {
//     title: "Certification of Incorporation",
//     description: "Registered under the Government of Nepal.",
//     image: neapallogo, // public folder path
//   },
//   {
//     title: "ISO Certified by URS",
//     description: "Certified ISO 9001:2015 for Quality Management.",
//     image: isours,
//   },
//   {
//     title: "Trademark Registered",
//     description: "Legally protected brand identity in Nepal.",
//     image: trademarklogo,
//   },
// ];

// export default function Certificates() {
//   return (
//     <div className="grid md:grid-cols-3 gap-8 px-4 max-w-7xl mx-auto py-12">
//       {certifications.map((cert, index) => (
//         <div
//           key={index}
//           className="bg-white p-6 rounded-xl shadow-md text-center hover:shadow-xl transition-all"
//         >
//           <img
//             src={cert.image}
//             alt={cert.title}
//             className="h-24 mx-auto mb-4 object-contain"
//           />
//           <h4 className="text-xl font-bold text-gray-800 mb-2">{cert.title}</h4>
//           <p className="text-gray-600 text-sm">{cert.description}</p>
//         </div>
//       ))}
//     </div>
//   );
// }

// import React from "react";
// import { Award, FileSearch, ShieldCheck } from "tabler-icons-react";
// import isours from "../image/iso-urs.png";
// import neapallogo from "../image/epal-logo.png";
// import trademarklogo from "../image/epal-logo.png";

// export default function CertificatesSection() {
//   const cards = [
//     {
//       title: "Certification of Incorporation",
//       description: "Officially registered under the Government of Nepal.",
//       logo: neapallogo,
//       bgGradient: "from-blue-50 to-blue-100",
//       iconBg: "bg-blue-500",
//       Icon: ShieldCheck,
//       label: "Govt. of Nepal",
//       labelColor: "text-blue-600",
//     },
//     {
//       title: "ISO Certified by URS",
//       description:
//         "Certified under ISO 9001:2015 for quality management systems and practices.",
//       logo: isours,
//       bgGradient: "from-green-50 to-green-100",
//       iconBg: "bg-green-500",
//       Icon: Award,
//       label: "Certified Since 2025",
//       labelColor: "text-green-600",
//     },
//     {
//       title: "Trademark Registered",
//       description:
//         "Our brand is officially trademarked and legally protected in Nepal.",
//       logo: trademarklogo,
//       bgGradient: "from-purple-50 to-purple-100",
//       iconBg: "bg-purple-500",
//       Icon: FileSearch,
//       label: "Trademark Verified",
//       labelColor: "text-purple-600",
//     },
//   ];

//   return (
//     <div className="mt-8">
//       <div className="text-center mb-12">
//         <h3 className="text-2xl font-bold text-gray-900 mb-4">
//           Certifications & Standards
//         </h3>
//         <p className="text-lg text-gray-600">
//           Our commitment to quality and excellence is recognized through various
//           certifications and legal registrations.
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
//         {cards.map((card, idx) => (
//           <div
//             key={idx}
//             className={`bg-gradient-to-br ${card.bgGradient} p-8 rounded-2xl text-center hover:shadow-lg transition-shadow`}
//           >
//             <div
//               className={`${card.iconBg} p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center`}
//             >
//               <card.Icon className="w-8 h-8 text-white" />
//             </div>
//             <h4 className="text-xl font-bold text-gray-900 mb-4">
//               {card.title}
//             </h4>
//             <p className="text-gray-600 mb-4">{card.description}</p>
//             <img
//               src={card.logo}
//               alt={card.title}
//               className="h-20 mx-auto mb-4 object-contain"
//             />
//             <div className="bg-white p-3 rounded-lg">
//               <span className={`text-sm font-semibold ${card.labelColor}`}>
//                 {card.label}
//               </span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

///view certificate addon
import React, { useState } from "react";
import { Award, FileSearch, ShieldCheck, X } from "tabler-icons-react";
import isours from "../image/iso-urs.png";
import neapallogo from "../image/epal-logo.png";
import trademarklogo from "../image/epal-logo.png";

import HexaIncorp from "../pdf/hexaindustry.pdf";
import HexaISO from "../pdf/hexaiso.pdf";
import HexaTrademark from "../pdf/Trademark_hexa.pdf";

export default function CertificatesSection() {
  const [selectedPDF, setSelectedPDF] = useState(null);

  const cards = [
    {
      title: "Certification of Incorporation",
      description: "Officially registered under the Government of Nepal.",
      logo: neapallogo,
      pdf: HexaIncorp,
      bgGradient: "from-blue-50 to-blue-100",
      iconBg: "bg-blue-500",
      Icon: ShieldCheck,
      label: "Govt. of Nepal",
      labelColor: "text-blue-600",
    },
    {
      title: "ISO Certified by URS",
      description:
        "Certified under ISO 9001:2015 for quality management systems and practices.",
      logo: isours,
      pdf: HexaISO,
      bgGradient: "from-green-50 to-green-100",
      iconBg: "bg-green-500",
      Icon: Award,
      label: "Certified Since 2025",
      labelColor: "text-green-600",
    },
    {
      title: "Trademark Registered",
      description:
        "Our brand is officially trademarked and legally protected in Nepal.",
      logo: trademarklogo,
      pdf: HexaTrademark,
      bgGradient: "from-purple-50 to-purple-100",
      iconBg: "bg-purple-500",
      Icon: FileSearch,
      label: "Trademark Verified",
      labelColor: "text-purple-600",
    },
  ];

  return (
    <div className="mt-8 relative">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Certifications & Standards
        </h3>
        <p className="text-lg text-gray-600">
          Our commitment to quality and excellence is recognized through various
          certifications and legal registrations.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {cards.map((card, idx) => (
          <div
            key={idx}
            className={`bg-gradient-to-br ${card.bgGradient} p-8 rounded-2xl text-center hover:shadow-lg transition-shadow`}
          >
            <div
              className={`${card.iconBg} p-4 rounded-full w-16 h-16 mx-auto mb-6 flex items-center justify-center`}
            >
              <card.Icon className="w-8 h-8 text-white" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-4">
              {card.title}
            </h4>
            <p className="text-gray-600 mb-4">{card.description}</p>
            <img
              src={card.logo}
              alt={card.title}
              className="h-20 mx-auto mb-4 object-contain"
            />
            <div className="bg-white p-3 rounded-lg mb-2">
              <span className={`text-sm font-semibold ${card.labelColor}`}>
                {card.label}
              </span>
            </div>
            <button
              onClick={() => setSelectedPDF(card.pdf)}
              className="bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition duration-200 text-sm"
            >
              View Certificate
            </button>
          </div>
        ))}
      </div>

      {selectedPDF && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-10">
          <div className="bg-white rounded-lg max-w-3xl w-full relative">
            {/* <button
              onClick={() => setSelectedPDF(null)}
              className="absolute top-2 right-6 p-2 text-gray-600 hover:text-black"
            >
              <X className="w-6 h-6" />
            </button> */}
            <button
              onClick={() => setSelectedPDF(null)}
              style={{ top: "0px", right: "-45px" }}
              className="absolute top-0 right-0 p-5 text-red-600 bg-white full shadow-md"
            >
              <X className="w-6 h-6" />
            </button>
            <iframe
              src={selectedPDF}
              title="PDF Viewer"
              className="w-full h-[80vh] rounded-b-lg"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
}
